import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const ArrowReverseIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M8.36379 6.17682L11.5 3.19905L10.3893 2L5.89951 6.17682H5.8125V6.25776L5 7.01363L5.8125 7.7834V7.83894H5.87113L10.2632 12L11.4014 10.7515L8.34773 7.83894L18 7.83894V6.17682L8.36379 6.17682Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M15.6255 17.8333L12.5 20.801L13.6107 22L18.0896 17.8333H18.1875V17.7422L19 16.9864L18.1875 16.2166V16.1667H18.1348L13.7368 12L12.5986 13.2485L15.6581 16.1667L6 16.1667L6 17.8333L15.6255 17.8333Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
ArrowReverseIcon.displayName = 'ArrowReverseIcon'
export default ArrowReverseIcon
